import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/report",

        async generate({ start, end }) {
            return Vue.http.post(this.url(`/?start=${start}&end=${end}`), {
                start,
                end,
            });
        },

        async status() {
            return Vue.http.get(this.url(`/info`));
        },
    },
    base
);
